// extracted by mini-css-extract-plugin
module.exports = {"List":"ReportsPage_List__9zmPn","ListItem":"ReportsPage_ListItem__YpAXj","Empty":"ReportsPage_Empty__Vx1Pl","Content":"ReportsPage_Content__315tz"};